import { useQuery } from 'react-query';
import { useViewerStore } from '@store/viewerModule/base';
import { getViewerExperience } from '@src/api/viewerModule';
import { buildAdvanceRequestBody } from '../common/utils';
import { GEO_CITY, GEO_ASN, SESSION } from '../common/constants';

const advanceMetrics = [
  'Bitrate',
  'ConnectionInducedRebufferingRatio',
  'PercentageComplete',
  'RebufferingRatio',
  'VideoRestartTime',
  'VideoStartFailures',
  'VideoStartTime',
];

function useViwerAdvanceData() {
  const [
    {
      viewerId,
      rowData: { SessionId },
      interval,
      filterId,
      geoData,
    },
  ] = useViewerStore();
  const { isLive } = interval;
  const { encodedGeo, asn, city } = geoData;
  const sessionQueryParams = buildAdvanceRequestBody(
    { viewerId, sessionId: SessionId },
    interval,
    advanceMetrics,
    SESSION,
  );
  const cityQueryParams = buildAdvanceRequestBody({ city }, interval, advanceMetrics, GEO_CITY);
  const asnQueryParams = buildAdvanceRequestBody({ asn }, interval, advanceMetrics, GEO_ASN);
  const paramList = [viewerId, filterId, encodedGeo, asn];

  // TODO: fid for testing: 97019,
  const cityData = useQuery(
    ['getCityData', ...paramList],
    () =>
      getViewerExperience({
        params: { ...cityQueryParams },
      }),
    {
      enabled: !!viewerId && !isLive,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  const sessionData = useQuery(
    ['getSessionData', ...paramList, SessionId],
    () =>
      getViewerExperience({
        params: { ...sessionQueryParams },
      }),
    {
      enabled: !!viewerId && !isLive,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  const asnData = useQuery(
    ['getASNData', ...paramList],
    () =>
      getViewerExperience({
        params: { ...asnQueryParams },
      }),
    {
      enabled: !!viewerId && !isLive,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  return {
    sessionData,
    cityData,
    asnData,
  };
}

export default useViwerAdvanceData;
